// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Z2386","mulShdSpin":"Loader_mulShdSpin__-Mn7f"};